import { EvidencePacket } from "@/features/oversight/evidence";

export default function EvidencePacketPage() {
  return <EvidencePacket />;
}
